/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import FullScreen from "../../../../components/FullScreen";
import Loader from "../../../../components/Loader/Index";
import BeneTransactionGridView from "../../../../components/Transactions/BeneTrasnaction/BeneTransactionGridView";
import {
  beneTxnUploadDetail,
  beneTxnViewAllAcc,
} from "../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import useCategories from "../../../../utils/useCategories";
import BulkTransactionViewAll from "../BulkTransactionViewAll";
import "./index.css";

const BulkTransactionDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const scrollRef = useRef();
  const scrollContainerRef = useRef(null);
  const categoryMapper = useCategories();
  const { id } = useParams();
  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [transactionData, setTransactionData] = useState([]);
  const [detaildata, setDetailData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [showCategorypopup, setShowCategoryPopup] = useState(false);
  const [categoryPass, setcategoryPass] = useState("");
  const [mainLoader, setMainLoader] = useState(true);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [index, setIndex] = useState(GlobalConfiguration.lengthCheckZero);

  const handleSelect = (value) => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  const handleViewCategory = (categories) => {
    setShowCategoryPopup(true);
    setcategoryPass(categories);
  };

  const formatToCustom = (date) => {
    const optionsDate = { day: "numeric", month: "short", year: "numeric" };
    const optionsTime = { hour: "numeric", minute: "2-digit", hour12: true };

    const datePart = date.toLocaleDateString("en-GB", optionsDate);
    const timePart = date
      .toLocaleTimeString("en-GB", optionsTime)
      .toLowerCase();

    return `${datePart}, ${timePart}`;
  };

  const handleFetch = async () => {
    setLoader(true);
    try {
      if (detaildata?.transaction_file?.transctions_ids?.length) {
        let data = await dispatch(
          beneTxnViewAllAcc({
            page_item_count: pageSize,
            page_no: currentPage,
            txn_id: detaildata?.transaction_file?.transctions_ids || [],
          }),
        );
        setTransactionData(data);
      }

      if (
        detaildata?.transaction_file?.file_status === "processed" ||
        detaildata?.transaction_file?.file_status === "failed"
      ) {
        setLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  useEffect(() => {
    setMainLoader(true);
    const fetchData = async () => {
      let response = await dispatch(beneTxnUploadDetail(id));

      if (response?.payload?.errors?.user_unauthorized?.length) {
        return navigate("/feature_not_assigned", {
          state: { unavailableService: "VTransactionUpload" },
        });
      }

      setDetailData(response?.payload);
      setMainLoader(false);
      setShowCategoryPopup(false);
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    const hasSuccess =
      (detaildata?.transaction_file?.transctions_ids?.length ??
        GlobalConfiguration.lengthCheckZero) >
      GlobalConfiguration.lengthCheckZero;

    const hasFailed =
      (detaildata?.transaction_file?.failed_transctions?.length ??
        GlobalConfiguration.lengthCheckZero) >
      GlobalConfiguration.lengthCheckZero;

    if (hasFailed) {
      setIndex(GlobalConfiguration.lengthCheckOne);
    } else if (hasSuccess) {
      setIndex(GlobalConfiguration.lengthCheckZero);
    }
  }, [detaildata]);

  useEffect(() => {
    if (detaildata?.status) {
      handleFetch();
    }
  }, [detaildata, currentPage, selectedValue]);

  return (
    <div className=" lg:h-screen w-full flex flex-col bg-primary-bg overflow-hidden ">
      {mainLoader ? (
        <div
          className={`absolute top-top-base z-z-index-fixed-ui h-height-full w-width-full flex justify-center items-center`}
        >
          <Loader />
        </div>
      ) : (
        <>
          {alertPopUp && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-Primary-black justify-center z-z-index-max bg-opacity-dark-opacity">
              <FullScreen
                type={"BulkUploadView"}
                // id={bene_txn_id}
                setAlertPopUp={setAlertPopUp}
                categoryPass={categoryPass}
              />
            </div>
          )}
          {showCategorypopup && (
            <div
              style={{ zIndex: "var(--z-index-modal)" }}
              className="fixed top-top-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
            >
              <LargePopupRedirect
                headerTitle="Bulk transactions view all"
                closeiconisLoading={false}
                closeiconhandleFunction={() => setShowCategoryPopup(false)}
                closeicon={
                  "https://q2pay.in/new_assets/common/create_flow/close.svg"
                }
                closeiconhoverOption="white"
                closeiconbtnType={"button"}
                closeiconisDisabled={false}
                closeicondisabledBgColor={""}
                closeiconbuttonRef={null}
                closeicontitle={"Close"}
                type={"BulkUploadDetails"}
              >
                <BulkTransactionViewAll
                  popType={"BulkUploadDetails"}
                  setShowCategoryPopup={setShowCategoryPopup}
                  categoryPass={categoryPass}
                />
              </LargePopupRedirect>
            </div>
          )}

          <div className="BeneTxnBulk_navbar_div">
            <div
              className={`fixed top-top-base  left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom 
             lg:hidden
             block`}
            >
              {" "}
              <TopNavComponent
                topNavHeader={globalText?.BENEFICIARY_TRANSACTIONS}
                isFormattingNotRequired
                topNavSubText="Bulk transaction detail"
                handleBack={(e) => {
                  navigate(GlobalConfiguration.navigate_back);
                }}
              />
            </div>
          </div>
          <div className="BeneTxnBulk_fisrt_div_wrapper">
            <div className="BeneTxnBulk_upper_div px-padding-md Qlg:px-padding-base">
              <div className="BeneTxnBulk_div_main">
                <div className="BeneTxnBulk_div">
                  <div className="BeneTxnBulk_div_mapper py-padding-sm Qmd:py-padding-base">
                    {" "}
                    <TitleSubtitlePair
                      title={detaildata?.transaction_file?.file_name}
                      titleColor="text-primary "
                      subtitle={"File name"}
                      alignRight={false}
                      hoverOption="white"
                      isBold={false}
                      variant="md"
                    />
                  </div>

                  <div className="BeneTxnBulk_borderdiv"></div>
                  <div className="BeneTxnBulk_div_mapper py-padding-sm Qmd:py-padding-base">
                    <TitleSubtitlePair
                      title={
                        detaildata?.transaction_file?.file_status ===
                        "processed"
                          ? detaildata?.transaction_file?.failed_transctions
                              ?.length +
                              detaildata?.transaction_file?.transctions_ids
                                ?.length || GlobalConfiguration.lengthCheckZero
                          : "NA"
                      }
                      titleColor="text-primary "
                      subtitle={"Total transactions"}
                      alignRight={false}
                      hoverOption="white"
                      isBold={false}
                      variant="md"
                    />
                  </div>
                  <div className="BeneTxnBulk_borderdiv"></div>
                  <div className="BeneTxnBulk_div_mapper py-padding-sm Qmd:py-padding-base ">
                    <TitleSubtitlePair
                      title={detaildata?.transaction_file?.file_status
                        ?.toLowerCase()
                        ?.replace(/^\w/, (c) => c.toUpperCase())}
                      titleColor={
                        detaildata?.transaction_file?.file_status ===
                        "processed"
                          ? "settled"
                          : detaildata?.transaction_file?.file_status ===
                              "failed"
                            ? "failed"
                            : "queued"
                      }
                      subtitle={"File status"}
                      alignRight={false}
                      hoverOption="white"
                      isBold={false}
                      variant="md"
                    />
                  </div>
                  <div className=" BeneTxnBulk_category">
                    <TopNavSmallButton
                      btnText={detaildata?.transaction_file?.category || ""}
                      handleFunction={() =>
                        handleViewCategory(
                          detaildata?.transaction_file?.category,
                        )
                      }
                      isDisabled={
                        detaildata?.transaction_file?.category === undefined &&
                        "none"
                      }
                      enabledTextColor="var(--text-secondary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="transparent"
                      icon={categoryMapper(
                        detaildata?.transaction_file?.category,
                      )}
                      hoverOption="white"
                      fullWidthRequired={false}
                    />
                  </div>
                </div>
              </div>
              <div className="border-t border-primary-bg"></div>
              <div className="BeneTxnBulk_div_main">
                <div className="BeneTxnBulk_div">
                  <div className="BeneTxnBulk_div_mapper pb-padding-sm Qmd:pb-padding-base">
                    <TitleSubtitlePair
                      title={formatToCustom(
                        new Date(detaildata?.transaction_file?.created_at),
                      )}
                      titleColor={"text-primary"}
                      subtitle={"Date and time"}
                      alignRight={false}
                      hoverOption="white"
                      isBold={false}
                      variant="md"
                    />
                  </div>
                  <div className="BeneTxnBulk_borderdiv"></div>
                  <div className="BeneTxnBulk_div_mapper  pt-padding-sm Qmd:py-padding-base">
                    <TitleSubtitlePair
                      title={detaildata?.transaction_file?.uploaded_by}
                      titleColor={"text-primary"}
                      subtitle={"Uploaded by"}
                      alignRight={false}
                      hoverOption="white"
                      isBold={false}
                      variant="md"
                    />
                  </div>
                  <div className="BeneTxnBulk_div_mapper  "></div>
                  <div
                    style={{ backgroundColor: "transparent" }}
                    className="BeneTxnBulk_category_wrapper"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${
              detaildata?.transaction_file?.category === undefined
                ? "BeneTxnBulk_conditionalbtn"
                : ""
            } BeneTxnBulk_QuickActionBtn`}
          >
            <div className="bg-primary-card w-width-full px-padding-md py-padding-sm">
              <p
                style={{
                  fontWeight: "var(--font-semibold)",
                  letterSpacing: "var(--letter-space)",
                }}
                className="BeneTxnBulk_header"
              >
                Quick Actions
              </p>
            </div>
            <div>
              <TopNavSmallButton
                btnText={detaildata?.transaction_file?.category || ""}
                handleFunction={() =>
                  handleViewCategory(detaildata?.transaction_file?.category)
                }
                isDisabled={
                  detaildata?.transaction_file?.category === undefined && "none"
                }
                enabledTextColor="var(--text-secondary)"
                enabledBgColor="var(--primary-nav-act)"
                disabledBgColor="transparent"
                icon={ICONS?.DEFAULT_CATEGORY}
                hoverOption="white"
                fullWidthRequired={true}
              />
            </div>
          </div>
          {detaildata?.transaction_file?.file_status === "failed" &&
          !detaildata?.transaction_file?.failed_transctions?.length ? (
            <div className="BeneTxnBulk_errordiv_wrapper">
              <div className="BeneTxnBulk_errordiv">
                <img
                  className="h-icon-md w-icon-md my-auto"
                  src={
                    "https://q2pay.in/new_assets/common/dashboard/alert_white.svg"
                  }
                  alt=""
                />
                <div className="h-fit flex flex-col gap-y-gap-sm">
                  <p className="BeneTxnBulk_normaltext">
                    Unable to Process File
                  </p>
                  <p
                    style={{ fontSize: "var(--font-xs)" }}
                    className="BeneTxnBulk_normaltext"
                  >
                    The uploaded transaction file couldn’t be processed. Please
                    check the file and upload it again.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{ height: loader && "var(--full-height)" }}
              ref={scrollRef}
              className="BeneTxnBulk_tablediv_wrapper overflow-y-auto h-full flex flex-col"
            >
              <div
                className={`w-width-full bg-primary-act h-fit fixed z-z-index-fixed-ui ${
                  index === GlobalConfiguration?.lengthCheckZero
                    ? "bottom-bottom-label-tab   pb-padding-sm"
                    : "bottom-bottom-base"
                }`}
              >
                <div className="BeneTxnBulk_tablebottom">
                  <p className="BeneTxnBulk_normaltext">
                    {index === GlobalConfiguration?.lengthCheckZero ? (
                      <>
                        Transactions created -{" "}
                        <span className="text-settled">
                          {
                            detaildata?.transaction_file?.transctions_ids
                              ?.length
                          }
                        </span>
                      </>
                    ) : (
                      <>
                        Transactions failed -{" "}
                        <span className="text-failed">
                          {
                            detaildata?.transaction_file?.failed_transctions
                              ?.length
                          }
                        </span>
                      </>
                    )}
                  </p>
                  <div className="BeneTxnBulk_tablebottom_download_div">
                    <p className="BeneTxnBulk_normaltext">
                      {index === GlobalConfiguration?.lengthCheckZero
                        ? "The above transactions has been created and sent for approval."
                        : "Fix the errors, and upload the corrected data as a new file."}
                    </p>
                  </div>
                </div>
              </div>

              {index === GlobalConfiguration?.lengthCheckZero && (
                <div
                  style={{
                    zIndex: "var(--z-index-fixed-ui)",
                    width: "var(--width-full)",
                    bottom: "var(--bottom-base)",
                  }}
                  className="fixed w-width-full h-pagination-height"
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={transactionData?.payload}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={() => {}}
                  />
                </div>
              )}

              <div className="BeneTxnBulk_tabdiv_wrapper">
                <div className="BeneTxnBulk_toggleBtn_div">
                  <SwitcherTabs
                    tabs={[
                      {
                        label: "Success transactions",
                        key: "Success transactions",
                        handler: () =>
                          setIndex(GlobalConfiguration.lengthCheckZero),
                        isDisabled:
                          !detaildata?.transaction_file?.transctions_ids
                            ?.length,
                      },
                      {
                        label: "Failed transactions",
                        key: "Failed transactions",
                        handler: () =>
                          setIndex(GlobalConfiguration.lengthCheckOne),
                        isDisabled:
                          !detaildata?.transaction_file?.failed_transctions
                            ?.length,
                      },
                    ]}
                    swicherTabBgColor={"var(--primary-card)"}
                    setIndex={setIndex}
                    initialActiveTab={
                      detaildata?.transaction_file?.failed_transctions?.length
                        ? "Failed transactions"
                        : "Success transactions"
                    }
                  />
                </div>
              </div>

              {index === GlobalConfiguration?.lengthCheckZero && (
                <>
                  {" "}
                  {loader ? (
                    <div
                      className={`absolute top-top-base flex-1 z-z-index-fixed-ui opacity-dark-opacity h-height-full w-width-full flex justify-center items-center  bg-PopUp-BackDrop`}
                    >
                      <div className="flex flex-col items-center">
                        <Loader />
                        <p
                          style={{
                            fontWeight: "var(--font-semibold)",
                            letterSpacing: "var(--letter-space)",
                          }}
                          className="BeneTxnBulk_normaltext"
                        >
                          Verifying data
                        </p>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        ref={scrollContainerRef}
                        className=" overflow-y-auto flex-1 flex  "
                      >
                        <BeneTransactionGridView
                          data={transactionData?.payload?.transactions}
                          isSidebarOpen={false}
                          isPopoverOpen={false}
                          isDistributionPopoverOpen={false}
                          typepop={"Bulk"}
                          onClose={() => {}}
                          currentStatus={""}
                          filterRef={scrollContainerRef}
                        />
                      </div>
                      <div className="h-topnav-bottom-height block lg:hidden"></div>
                    </>
                  )}
                </>
              )}

              {index === GlobalConfiguration?.lengthCheckOne && (
                <>
                  {" "}
                  <div className="BeneTxnBulk_table_div_main">
                    <div className="BeneTxnBulk_table_div_header">
                      <div className="BeneTxnBulk_table_div_header_div">
                        <p className="text-font-xs py-padding-md text-text-secondary">
                          Row no.
                        </p>
                      </div>
                      <div className="border-r border-primary-bg"></div>
                      <div
                        style={{ flex: "1", textAlign: "left" }}
                        className="BeneTxnBulk_table_div_header_div"
                      >
                        <p className="text-font-xs py-padding-md h-icon-sm text-text-secondary">
                          Error message
                        </p>
                      </div>
                    </div>
                    <div className="BeneTxnBulk_table_div_data">
                      {detaildata?.transaction_file?.failed_transctions?.map(
                        (data) => {
                          return (
                            <div
                              key={data?.row_number}
                              className="BeneTxnBulk_table_div_mapper border-b border-primary-nav-act"
                            >
                              <div
                                style={{
                                  justifyContent: "center",
                                  height: "auto",
                                }}
                                className="BeneTxnBulk_table_div_data_div"
                              >
                                <p className="text-font-xs h-fit text-text-secondary">
                                  {data?.row_number || "–"}
                                </p>
                              </div>
                              <div></div>
                              <div
                                style={{ flex: "1" }}
                                className="BeneTxnBulk_table_div_data_div"
                              >
                                <p className="text-font-xs break-all h-fit text-text-secondary">
                                  {data?.error}
                                </p>
                              </div>
                            </div>
                          );
                        },
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BulkTransactionDetails;
